<script setup>
import { useEventTracking } from '#imports';
import { HOST_NAME } from '~/constants/service-urls';

const googlePreferredSourceUrl = `https://www.google.com/preferences/source?q=${HOST_NAME}`;
</script>

<template>
  <div class="google-source-banner">
    <a
      :href="googlePreferredSourceUrl"
      class="google-source-banner__link"
      target="_blank"
      rel="noopener"
      @click="
        useEventTracking('click', 'Click on Google preferred source banner')
      "
    >
      Сделайте DOXA вашим источником новостей в Google
    </a>
  </div>
</template>

<style scoped lang="postcss">
.google-source-banner {
  max-width: var(--content-max-width);
  padding: 16px 60px 24px;
  margin: 0 auto;

  &__link {
    display: block;
    overflow: hidden;
    width: 872px;
    max-width: 100%;
    aspect-ratio: 2766 / 129;
    transition: var(--default-transition) opacity;
    white-space: nowrap;
    text-indent: 100%;
    color: transparent;
    background: url('~/assets/images/google-preferred-source.svg') no-repeat
      center / contain;

    &:hover {
      opacity: 0.9;
    }
  }

  @media (--small-vp) {
    padding: 0 16px 16px;

    &__link {
      width: 100%;
    }
  }
}
</style>
